var _a, _b, _c;
import { generateActions } from "../generators/generator.actions";
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./invoice.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["MarkPaid"] = "MARK_PAID";
    EActionCustom["MarkUnPaid"] = "MARK_UNPAID";
})(EActionCustom || (EActionCustom = {}));
var generateMarkPaidActions = function () { return ({
    markInvoicePaidStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkPaid,
        state: EActionState.Start,
    }),
    markInvoicePaidSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkPaid,
        state: EActionState.Success,
    }),
    markInvoicePaidFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkPaid,
        state: EActionState.Fail,
    }),
}); };
var generateMarkUnPaidActions = function () { return ({
    markInvoiceUnPaidStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkUnPaid,
        state: EActionState.Start,
    }),
    markInvoiceUnPaidSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkUnPaid,
        state: EActionState.Success,
    }),
    markInvoiceUnPaidFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkUnPaid,
        state: EActionState.Fail,
    }),
}); };
export var getDetailStart = (_a = generateActions(GENERATOR_PARAMS), _a.getDetailStart), getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed, getPagedStart = _a.getPagedStart, getPagedFailed = _a.getPagedFailed, getPagedSucceeded = _a.getPagedSucceeded, getCountStart = _a.getCountStart, getCountFailed = _a.getCountFailed, getCountSucceeded = _a.getCountSucceeded;
export var markInvoicePaidStart = (_b = generateMarkPaidActions(), _b.markInvoicePaidStart), markInvoicePaidSucceeded = _b.markInvoicePaidSucceeded, markInvoicePaidFailed = _b.markInvoicePaidFailed;
export var markInvoiceUnPaidStart = (_c = generateMarkUnPaidActions(), _c.markInvoiceUnPaidStart), markInvoiceUnPaidSucceeded = _c.markInvoiceUnPaidSucceeded, markInvoiceUnPaidFailed = _c.markInvoiceUnPaidFailed;
